import React from 'react';
import Text from 'components/Text/Text';
import { Form, Checkbox } from 'antd';

interface IProps {
	toggleFiscalized: () => void;
	isFiscalized: boolean;
}

export const IsFiscalized: React.FC<IProps> = ({ toggleFiscalized, isFiscalized }) => {
	return (
		<Form.Item name="isFiscalized">
			<Checkbox checked={isFiscalized} onChange={toggleFiscalized}>
				<Text translationNameSpace="form" translationKey="isFiscalizedLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
};
